/* app/js/src/components/calendar/calendar-filter-sec-events/calendar-filter-sec-events.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.filter-container {
  display: flex;
}
.filter-icon-container {
  cursor: pointer;
}
.hidden {
  display: none;
}
.sec-events-filter {
  position: absolute;
  background: white;
  top: 100%;
  right: 0;
  z-index: 2000;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  -webkit-user-select: none;
  user-select: none;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 202px;
  padding-bottom: 10px;
}
.sec-events-filter.active {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.top-items {
  font-size: 10px;
  font-weight: 700;
  margin-left: 11.72px;
  margin-top: 13px;
  display: flex;
  justify-content: space-between;
  margin-right: 5px;
}
.clear-all-button {
  background-color: white;
  border: none;
  outline: none;
  text-decoration: underline;
}
.checkboxes {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.checkboxes .checkbox-row {
  height: 30px;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
}
/*# sourceMappingURL=calendar-filter-sec-events.component.css.map */
